export default __webpack_public_path__ + "static/media/kk.9cc3f8c8.svg";